<template>
  <div>
    <UiTab v-for="tab in tabs" :key="tab.key" :tag="tag" :tab="tab" @click="tabСlick($event)">
      {{ tab.label }}
    </UiTab>
  </div>
</template>

<script>
import UiTab from './UiTab.vue'

export default {
  components: { UiTab },
  props: {
    /**
     * Root element tag of UiTab component.
     *
     * @values div, span, a, routerLink, etc...
     */
    tag: {
      type: String,
      default: 'div',
    },

    /**
     * Array of tabs objects
     *
     * @see [UiTab](#uitab)
     */
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    /**
     *  Click tab event
     *
     * @event tab-click
     * @property {object} tab event value
     */
    tabСlick(event) {
      this.$emit('tab-click', event)
    },
  },
}
</script>

<docs>
UiTab example:
```vue
<template>
  <UiTabs tag="div" :tabs="tabs" @tab-click="handleTabClick" />
</template>

<script>
import UiTabs from '@/components/tabs/UiTabs.vue'

export default {
  components: { UiTabs },
  computed: {
    /** Array of Tabs */
    tabs() {
      return [
        {
          key: 'all',
          label: 'All',
          isActive: false,
        },
        {
          key: 'error',
          label: 'Errors',
          isActive: true,
        },
        {
          key: 'warnings',
          label: 'Warnings',
          isActive: false,
        },
        {
          key: 'user',
          label: 'User',
          isActive: false,
        },
        {
          key: 'info',
          label: 'Info',
          isActive: false,
        },
      ]
    },
  },
}
</script>

```
</docs>
